module.exports = __webpack_public_path__ + "img/fall_leaves.502d536a.jpg";